import { render, staticRenderFns } from "./carryoutdetaile.vue?vue&type=template&id=fa2a6340&scoped=true"
import script from "./carryoutdetaile.vue?vue&type=script&lang=js"
export * from "./carryoutdetaile.vue?vue&type=script&lang=js"
import style0 from "./carryoutdetaile.vue?vue&type=style&index=0&id=fa2a6340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2a6340",
  null
  
)

export default component.exports